import { TrendingDown, TrendingUp } from "lucide-react";
import { cn } from "../lib/utils";

export interface ChartSingleStatProps {
  value: number | string;
  label?: string;
  description?: string;
  trend?: {
    value: number;
    direction: "up" | "down";
  };
  className?: string;
}

export const ChartSingleStat = ({ value, label, description, trend, className }: ChartSingleStatProps) => {
  const formattedValue = typeof value === "number" ? value.toLocaleString() : value;

  return (
    <div className={cn("flex flex-col gap-1 p-4", className)}>
      <div className="flex items-baseline gap-2">
        <span className="text-4xl font-bold text-foreground">{formattedValue}</span>
        {trend && (
          <div
            className={cn(
              "flex items-center gap-0.5 text-sm font-medium",
              trend.direction === "up" ? "text-green-600" : "text-red-600"
            )}
          >
            {trend.direction === "up" ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
            <span>{trend.value}%</span>
          </div>
        )}
      </div>
      {label && <span className="text-sm font-medium text-muted-foreground">{label}</span>}
      {description && <span className="text-xs text-muted-foreground">{description}</span>}
    </div>
  );
};
